/**
 * Time unit associated with the floating rate index.
 * tag: 40791
 * @readonly
 * @enum {string} (String)
 */
export enum PaymentStreamRateIndexCurveUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
